import { FilterDateRangeType, GenericFilterModel } from 'traveldesk-ui'
export default class InventoryFilter extends GenericFilterModel {
    PeriodStart?: FilterDateRangeType //{ StartDate: moment.Moment; EndDate: moment.Moment }
    PeriodEnd?: FilterDateRangeType //{ StartDate: moment.Moment; EndDate: moment.Moment }    
}
